import { createFileRoute } from "@tanstack/react-router"
import { AixContentBody, Loader } from "@aix/ui"
import { ReactElement } from "react"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import VidmaxSingleSeries from "~/components/VidMax/VidmaxSingleSeries"
import AppLayout from "~/layouts/AppLayout"
import { api } from "~/utils/api"

const VidmaxSeriesPage = () => {
  const { seriesId } = Route.useParams()

  const { data: series, isLoading } = api.series.getSeriesById.useQuery({ id: seriesId }, { enabled: !!seriesId })

  const breadcrumbItems = [{ label: "Series", href: "/home" }, { label: series?.title || "Loading..." }]

  if (isLoading) {
    return (
      <>
        <BreadcrumbBanner backUrl="/home" items={breadcrumbItems} />

        <AixContentBody innerClassName="items-center justify-center text-muted-foreground">
          <Loader />
        </AixContentBody>
      </>
    )
  }

  if (!series) {
    return (
      <>
        <BreadcrumbBanner backUrl="/home" items={breadcrumbItems} />

        <AixContentBody innerClassName="items-center justify-center text-muted-foreground">
          <span>Series not found</span>
        </AixContentBody>
      </>
    )
  }

  return (
    <>
      <BreadcrumbBanner backUrl="/home" items={breadcrumbItems} />

      <AixContentBody>
        <VidmaxSingleSeries id={seriesId} series={series} />
      </AixContentBody>
    </>
  )
}

function VidmaxSeriesPageWrapper() {
  return (
    <AppLayout>
      <VidmaxSeriesPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/series/$seriesId")({
  component: VidmaxSeriesPageWrapper,
})
